"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabCloseButton = exports.HeaderSubMenuItem = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FocusStyles = require("../../../../../../FocusStyles");
var _Link = require("../../../../../../Link");
var _SubMenu = require("../../../../SubMenu/SubMenu.style");
const TabCloseButton = exports.TabCloseButton = _styledComponents.default.button.withConfig({
  displayName: "Announcementsstyle__TabCloseButton",
  componentId: "sc-ep3jia-0"
})(["position:absolute;z-index:1;pointer-events:none;opacity:0;right:10px;top:10px;", ";", ";&:active,&:hover,&:focus{opacity:1;pointer-events:all;}"], _Link.linkStyle, _FocusStyles.focusStyles);
const HeaderSubMenuItem = exports.HeaderSubMenuItem = (0, _styledComponents.default)(_SubMenu.SubMenuItem).withConfig({
  displayName: "Announcementsstyle__HeaderSubMenuItem",
  componentId: "sc-ep3jia-1"
})(["border-bottom:solid 1px #e5e8ec;"]);